import { filterBy } from "neetocist";
import { dateFormat } from "neetocommons/utils";
import { Callout, Typography, Button } from "neetoui";
import { Trans } from "react-i18next";

import { SUBSCRIPTION_STATUS } from "./constants";
import "./subscription-notifications.scss";
import { useFetchSubscriptions } from "./useSubscriptionsApi";

const SubscriptionNotificationsContainer = () => {
  const { data } = useFetchSubscriptions();
  const clientAppSubscriptions = data?.clientAppSubscriptions ?? [];

  const visibleNotifications = filterBy(
    { status: SUBSCRIPTION_STATUS.past_due },
    clientAppSubscriptions
  );

  return (
    <>
      {visibleNotifications.map(
        ({ downgradeScheduledAt, customerPortalUrl }, index) => (
          <Callout
            className="neeto-molecules-subscription-notifications w-full p-2.5"
            data-testid="subscription-notifications"
            key={index}
            style="warning"
          >
            <Typography style="body2">
              <Trans
                i18nKey="neetoMolecules.subscription.paymentFailedNotification"
                components={{
                  a: (
                    <Button
                      href={customerPortalUrl}
                      rel="noreferrer"
                      style="link"
                      target="_blank"
                    />
                  ),
                }}
                values={{
                  downgradeScheduledAt: dateFormat.date(downgradeScheduledAt),
                }}
              />
            </Typography>
          </Callout>
        )
      )}
    </>
  );
};

export default SubscriptionNotificationsContainer;
